import { useTranslation } from "react-i18next";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { useWishlist } from "@/context/WishlistContext";

export const WishlistButton = ({ p, size = "sm", className = "" }) => {
  const { t } = useTranslation();
  const { has, toggle } = useWishlist();
  const active = has(p.code);
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const added = toggle(p.code);
    toast(added ? t("wishlist.added") : t("wishlist.removed"), { description: p.name });
  };
  const dim = size === "lg" ? "h-14 w-14" : "h-9 w-9";
  return (
    <motion.button
      type="button"
      onClick={onClick}
      whileTap={{ scale: 0.8 }}
      data-testid={`wishlist-toggle-${p.code}`}
      aria-pressed={active}
      aria-label={active ? t("wishlist.removed") : t("wishlist.add")}
      className={`grid ${dim} place-items-center rounded-full border transition-[background-color,border-color,color] ${active ? "border-[#c6ff00] bg-[#c6ff00] text-black" : "border-black/10 bg-white/90 text-black/60 backdrop-blur hover:border-black hover:text-black"} ${className}`}
    >
      <motion.span key={active ? "on" : "off"} initial={{ scale: 0.6 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 500, damping: 18 }}>
        <Heart size={size === "lg" ? 22 : 16} fill={active ? "currentColor" : "none"} />
      </motion.span>
    </motion.button>
  );
};
